import React, { useContext, useState, useRef, useEffect } from 'react'
import '../../../assets/css/header.css';
import { UserContext } from '../../../context/userContext';
import { deleteToken, API } from '../../../http-common';
import { useHistory } from 'react-router-dom';
import { ModalSwitchBusiness } from '../Modal/ModalSwtichBusiness';
import { getBusinessName, getNextBusinessName, ROLE, BUSINESS, CREATE_PRODUCTOR_ROLES } from '../../../helpers/constants';
import { useFeature, FEATURES } from '../../../context/FeaturesContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faPlus, faPowerOff, faShareAlt, faSyncAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { PROSPECT_FORM_URL } from '../../../constants';

const Header = ({ hideBusinessBadge = false }) => {

  const history = useHistory();
  const { userData, setUserData } = useContext(UserContext);

  const [switching, setSwitching] = useState(false);
  const [openSwitchModal, setOpenSwitchModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const menuRef = useRef(null);
  const isAsesor = [ROLE.EQ_COMERCIAL, ROLE.EQ_TEAM_LEADER].includes(Number(userData?.role_id));

  const subProspectsEnabled = useFeature(FEATURES.SUBPROSPECTS);
  const showUserPrincipal = subProspectsEnabled && CREATE_PRODUCTOR_ROLES.includes(userData?.role_id);

  useEffect(() => {
    if (!menuOpen) return;
    const onClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    const onEsc = (e) => e.key === "Escape" && setMenuOpen(false);
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEsc);
    };
}, [menuOpen]);

  const isSwitchableBusiness = [BUSINESS.IFA, BUSINESS.CANALES].includes(Number(userData?.business_id));
  const showSwitcher = userData?.canSwitch === true && isSwitchableBusiness && !hideBusinessBadge;
  
  const currentName = getBusinessName(userData?.business_id);
  const nextName = getNextBusinessName(userData?.business_id);
  

  const handleLogout = () => {
    deleteToken();
    setUserData(null);
    history.push("/admin/login");
  };

  const handleShareAdvisorLink = async () => {
    const advisorLink = `${PROSPECT_FORM_URL}?ref=${userData?.email ?? ""}`;
    try {
      await navigator.clipboard.writeText(advisorLink);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (error) {
      console.error("Error al copiar link:", error);
      alert("No se pudo copiar el link.");
    }
  };

  const handleSwitchBusiness = async () => {
    try {
      setSwitching(true);

      const sw = await API.post("/user/switch-business");
      const newBusinessId = sw?.data?.business_id;

      const me = await API.get("/user/whoami");
      const nextUser = me?.data?.user ?? me?.data?.data;

      if (nextUser) {
        setUserData({
          ...nextUser,
          business_id: newBusinessId ?? nextUser.business_id,
        });
      }
    } catch (error) {
      console.error("Error al cambiar business:", error);
      alert(
        error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.message ||
        "Error al cambiar de unidad de negocio."
      );
    } finally {
      setSwitching(false);
    }
  };

  return (
    <header className="row header_row">
      <div className="col-md" id="container_brand">
        <span className="header_title">BALANZ</span>
        {userData?.business_id != null && !hideBusinessBadge && (
          <span className="header_business_badge">
            Unidad: {currentName}
          </span>
        )}

      </div>

      <div className="col-md" id="container_user">
        <div className="header_dropdown" ref={menuRef}>
          <button
           type="button"
            className="header_dropdown_toggle"
            onClick={() => setMenuOpen((o) => !o)}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            <span className="username">{userData?.username}</span>
            <FontAwesomeIcon icon={faUserCircle} className="header_dropdown_avatar" />
            <FontAwesomeIcon icon={faCaretDown} className={`header_dropdown_caret${menuOpen ? " open" : ""}`} />
          </button>

          {menuOpen && (
            <ul className="header_dropdown_menu" role="menu">
              {showUserPrincipal && (
                <li>
                  <button
                    type="button"
                    role="menuitem"
                    onClick={() => { setMenuOpen(false); history.push("/admin/users/principal"); }}
                  >
                    <FontAwesomeIcon icon={faPlus} fixedWidth />
                    Agregar Productor (AP)
                  </button>
                </li>
              )}
              {showSwitcher && (
                <li>
                  <button
                    type="button"
                    role="menuitem"
                    disabled={switching}
                    onClick={() => { setMenuOpen(false); setOpenSwitchModal(true); }}
                  >
                    <FontAwesomeIcon icon={faSyncAlt} fixedWidth />
                    Cambiar unidad
                  </button>
                </li>
              )}
              {isAsesor && (
                <li>
                  <button type="button" role="menuitem" onClick={handleShareAdvisorLink}>
                    <FontAwesomeIcon icon={faShareAlt} fixedWidth />
                    {linkCopied ? "¡Link copiado!" : "Compartir link asesor"}
                  </button>
                </li>
              )}
              <li>
                <button type="button" role="menuitem" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faPowerOff} fixedWidth />
                  Cerrar sesión
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>

      {showSwitcher && (
        <ModalSwitchBusiness
          isOpen={openSwitchModal}
          onClose={() => setOpenSwitchModal(false)}
          currentName={currentName}
          nextName={nextName}
          confirmDisabled={switching}
          confirmText={switching ? "Cambiando..." : "Sí, cambiar"}
          onConfirm={async () => {
            setOpenSwitchModal(false);
            await handleSwitchBusiness();
          }}
        />
      )}
    </header>
  );
};

export default Header;
